module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2319013.513d915c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2319013.pdf
// module id = 829
// module chunks = 0